module.exports = __webpack_public_path__ + "img/郭建淼.21e7f1c0.jpg";